<template>
  <div class="w100p pl10 pr10">
    <div class="textc mb20">
      <p class="textc fs9  fwbold">{{ $t('miniprogram', 'couponModule') }}</p>
      <p class="fs7">{{ $t('miniprogram', 'demoCouponNote') }}</p>
    </div>
    <div class="">
      <p class="fs8 mb10">
        {{ $t('miniprogram', 'moduleName') }}
      </p>
      <el-input :placeholder="listData.title" v-model="listData.title" maxlength="15" show-word-limit
        class="mb10 w200 ml20"></el-input>
    </div>
    <p class="fs8 mt10 mb10">
      {{ $t('miniprogram', 'couponSettings') }}
    </p>
    <div class="" v-for="(item,index) in listData.list" :key="index">
      <div class="bgc0 ml10 pt5 pr5 pl5 pl5 pb10 mb10">
        <p>{{ $t('miniprogram', 'couponName') }}：{{item.name}}</p>
        <div>
          <p v-if="item.couponType == 1">{{ $t('miniprogram', 'couponContent') }}：{{ $t('miniprogram', 'full') }}{{item.minAmount}}{{ $t('miniprogram', 'minus') }}{{item.couponFaceValue}}{{ $t('miniprogram', 'yuan') }}</p>
          <p v-else>{{ $t('miniprogram', 'full') }}{{item.minAmount}}{{ $t('miniprogram', 'discount') }}{{item.couponDiscount}}{{ $t('miniprogram', 'off') }}</p>
          <div class="d-flex mb10">
            <p>{{ $t('miniprogram', 'couponTime') }}：{{item.grantStartTime}}{{ $t('miniprogram', 'to') }}{{item.grantEndTime}}</p>
          </div>
          
        </div>
        <div class="flex-a-b-c ml10 mt20 mb10">
          <el-button type="primary" @click="choice_tap(index)">{{ $t('miniprogram', 'selectCoupon') }}</el-button>
        </div>

      </div>

    </div>
    <el-dialog :title="$t('miniprogram', 'selectCoupon')" width="70%" :center="true" :modal-append-to-body="false"
      :visible="dialogTableVisible" @close="dialogClose">
      <commonTable :tableData="memberData" :loading="loading" @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange" v-if="memberData.length > 0" :total="total">
        <template v-slot:table>
          <el-table-column align="center" width="100" :label="$t('miniprogram', 'selectCoupon')">
            <template slot-scope="scope">
              <el-radio :label="scope.row.couponId" v-model="selectGoodsId"
                @change="getTemplateRow(scope.$index,scope.row)"></el-radio>
            </template>
          </el-table-column>
          <el-table-column prop="name" align="center" :label="$t('miniprogram', 'couponName')" />
          <el-table-column align="center" :label="$t('miniprogram', 'couponContent')" show-overflow-tooltip >
            <template slot-scope="scope">
              <p v-if="scope.row.couponType == 1">{{ $t('miniprogram', 'full') }}{{scope.row.minAmount}}{{ $t('miniprogram', 'minus') }}{{scope.row.couponFaceValue}}{{ $t('miniprogram', 'yuan') }}</p>
              <p v-else>{{ $t('miniprogram', 'full') }}{{scope.row.minAmount}}{{ $t('miniprogram', 'discount') }}{{scope.row.couponDiscount}}{{ $t('miniprogram', 'off') }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" width="210px" align="center" :label="$t('miniprogram', 'couponActivityTime')">
            <template slot-scope="scope">
              {{ scope.row.grantStartTime  }} - {{scope.row.grantEndTime}}
            </template>
          </el-table-column>
        </template>
      </commonTable>
      <div class="flex-c-c w100P flex-column pt20 pb10" v-else-if="memberData.length == 0">
        <p class="mb20">{{ $t('miniprogram', 'noCoupons') }}，{{ $t('miniprogram', 'needSetCoupons') }}</p>
        <el-button type="primary" plain @click="setGoods">
          {{ $t('miniprogram', 'goToSet') }}
        </el-button>
      </div>
      <div class="mt40 flex-c-c">
        <el-button type="primary" plain @click="cancel">
          {{ $t('miniprogram', 'cancel') }}
        </el-button>
        <el-button type="primary" @click="onConfirmShop">
          {{ $t('miniprogram', 'confirm') }}
        </el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>

  import {
    getGoodsInfoPCShop,
  } from "@/api/miniProgram";
  import { crmPcPageList, } from "@/api/coupon";
  import { getDataTimeSec } from "@/utils";
  import commonTable from "@/components/common/commonTable";
  import i18nMixin from '@/mixins/i18nMixin';

  export default {
    mixins: [i18nMixin],
    props: ['listData', , 'showTips'],
    data() {
      return {
        currentIndex: '',
        currentPage: 1,
        pageSize: '',
        memberData: '',
        total: '',
        dialogTableVisible: false,
        loading: false,
        selectGoodsId: '',
        currentGoods: ''
      };
    },
    components: {
      commonTable
    },
    created() {
      this.queryShop()
    },
    filters: {
      getDataTimeSec(val) {
        return getDataTimeSec(val, 'yy-mm-dd');
      }
    },
    methods: {
      queryShop() {
        let data = {
          pageNum: this.currentPage
        }
        this.loading = true
        let than = this
        crmPcPageList(data)
          .then(res => {
            
            if (res.data) {
              this.loading = false;
              this.memberData = res.data.list || []
              this.total =  res.data.total
            } else {
              this.memberData = []
            }
          })
          .catch(err => {
            this.loading = false;
          })
      },
      choice_tap(index) {
        this.queryShop()
        this.currentIndex = index
        this.selectGoodsId = this.listData.list[index].couponId ? this.listData.list[index].couponId : ''
        this.dialogTableVisible = true
      },
      handleSizeChange(val) {
        this.pageSize = val;
      },
      handleCurrentChange(val) {
        
        this.currentPage = val;
        this.$emit('dialogCurrentChange', val);
      },
      dialogClose() {
        this.dialogTableVisible = false
      },
      getTemplateRow(index, row) {
        this.currentGoods = row
      },
      onConfirmShop() {
        let type = this.listData.type
        let than = this
        let list = than.listData.list
        for (var i in list) {
          if (list[i].couponId == than.currentGoods.couponId) {
            this.dialogTableVisible = false
            return than.$message.error(this.$t('miniprogram', 'couponAlreadySelected'))
          }
        }
        than.$emit('confirmSeckill', than.currentIndex, than.currentGoods, type)
        this.dialogTableVisible = false
        than.currentGoods = ''

      },
      //取消
      cancel() {
        this.dialogTableVisible = false
      },
      //设置商品
      setGoods() {
        this.$router.push('/couponList')
      },
    }
  };
</script>

<style lang="scss" scoped>

</style>